(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-chart"] && !Shopify.designMode) return;
  try {
    
  class SizeChartComponent extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.sizechart__tab'));
      this.panels = Array.from(this.querySelectorAll('.sizechart__panel'));
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('keydown', (e) => {
          let next = null;
          if (e.key === 'Home') next = this.tabs[0];
          else if (e.key === 'End') next = this.tabs[this.tabs.length - 1];
          else {
            const dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
            if (!dir) return;
            next = this.tabs[(i + dir + this.tabs.length) % this.tabs.length];
          }
          e.preventDefault();
          next.focus();
          this.select(next);
        });
      });

      this.querySelectorAll('.sizechart__row').forEach((row) => {
        const pick = () => this.pickRow(row);
        row.addEventListener('click', pick);
        row.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            pick();
          }
        });
      });

      // Tema editorunde bir kategori blogu secilince o panel one gelsin
      this.onBlockSelect = (e) => {
        const panel = e.target && e.target.closest ? e.target.closest('.sizechart__panel') : null;
        if (!panel || !this.contains(panel)) return;
        this.select(this.tabs.find((t) => t.dataset.panel === panel.dataset.panel));
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.finderInputs = Array.from(this.querySelectorAll('[data-input]'));
      this.finderInputs.forEach((input) => {
        input.addEventListener('input', () => this.updateFinder());
      });

      this.gender = 'kiz';
      this.targetSize = null;
      this.querySelectorAll('[data-gender]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.gender = btn.dataset.gender;
          this.querySelectorAll('[data-gender]').forEach((b) => b.classList.toggle('is-on', b === btn));
          this.updateFinder();
        });
      });
      this.querySelectorAll('[data-targetSize], [data-target-size]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const val = btn.dataset.targetSize;
          const same = this.targetSize === val;
          this.targetSize = same ? null : val;
          this.querySelectorAll('[data-target-size]').forEach((b) =>
            b.classList.toggle('is-on', !same && b === btn)
          );
          this.updateFinder();
        });
      });
      this.activePanel = this.panels.find((p) => !p.classList.contains('is-hidden')) || null;
      if (this.finderInputs.length) this.updateFinder();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    /* Her panelin tablosunu oku: kategori adi, sutun anlamlari ve beden satirlari */
    readTables() {
      if (this._tables) return this._tables;
      this._tables = this.panels
        .filter((p) => p.dataset.panel !== 'finder')
        .map((p) => {
          const tab = this.tabs.find((t) => t.dataset.panel === p.dataset.panel);
          const head = Array.from(p.querySelectorAll('thead th')).map((th) => th.textContent.trim());
          const lengthIdx = head.findIndex((h) => /boy/i.test(h));
          const widthIdx = head.findIndex((h) => /göğüs|gogus|basen/i.test(h));
          const rows = Array.from(p.querySelectorAll('tbody tr')).map((tr) => {
            const cells = Array.from(tr.children).map((c) => c.textContent.trim());
            return {
              size: cells[0],
              length: parseFloat(String(cells[lengthIdx]).replace(',', '.')),
              width: parseFloat(String(cells[widthIdx]).replace(',', '.')),
            };
          });
          return {
            panel: p.dataset.panel,
            title: tab ? tab.textContent.trim() : '',
            isBottom: /basen/i.test(head[widthIdx] || ''),
            rows: rows,
          };
        })
        .filter((t) => t.rows.length);
      return this._tables;
    }

    /* Boy ve kilodan tahmini vucut cevresi (gogus / basen), tek yon olarak yarisi */
    bodyHalf(height, weight, isBottom) {
      const chest = 0.6 * weight + 0.11 * height + 41;
      const hip = 0.62 * weight + 0.13 * height + 36;
      return ((isBottom ? hip : chest) / 2);
    }

    /* Tablolarda gercekten bulunan bedenler (asistan bunun disina cikmasin) */
    availableSizes() {
      const set = new Set();
      this.panels.forEach((p) => {
        p.querySelectorAll('.sizechart__row[data-size]').forEach((r) => set.add(r.dataset.size));
      });
      return set;
    }

    select(tab) {
      if (!tab) return;
      const target = tab.dataset.panel;
      this.tabs.forEach((t) => {
        const on = t === tab;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((p) => {
        p.classList.toggle('is-hidden', p.dataset.panel !== target);
      });
      this.activePanel = this.panels.find((p) => p.dataset.panel === target) || null;
      this.updateFinder();
    }

    pickRow(row) {
      const panel = row.closest('.sizechart__panel');
      panel.querySelectorAll('.sizechart__row').forEach((r) => {
        r.classList.remove('is-picked');
        r.setAttribute('aria-pressed', 'false');
      });
      row.classList.add('is-picked');
      row.setAttribute('aria-pressed', 'true');
      const caption = panel.querySelector('[data-figure-caption]');
      if (!caption) return;
      const head = Array.from(panel.querySelectorAll('thead th')).map((th) => th.textContent.trim());
      const cells = Array.from(row.children).map((c) => c.textContent.trim());
      const parts = cells.slice(1).map((v, i) => (head[i + 1] ? head[i + 1] + ': ' + v : v)).filter(Boolean);
      caption.textContent = cells[0] + ' — ' + parts.join(' · ');
    }

    /* Her urun icin secilen bedenin uyum karti */
    renderFits(height, weight, recommended) {
      const host = this.querySelector('[data-fits]');
      if (!host) return;
      const wanted = this.targetSize || recommended;

      const cards = this.readTables().map((t) => {
        const row = t.rows.find((r) => r.size === wanted);
        const bodyHalf = this.bodyHalf(height, weight, t.isBottom);

        if (!row || !isFinite(row.width)) {
          return (
            '<article class="scfit scfit--na"><header class="scfit__head"><span class="scfit__name">' +
            t.title +
            '</span><span class="scfit__badge scfit__badge--na">yok</span></header>' +
            '<p class="scfit__verdict">Bu üründe ' + wanted + ' bedeni bulunmuyor.</p></article>'
          );
        }

        const ease = row.width - bodyHalf; // tek yon pay
        let level, verdict;
        if (ease < 1) {
          level = 'tight';
          verdict = 'Dar kesim — sıkabilir, bir üst beden öneririz';
        } else if (ease < 6) {
          level = 'ideal';
          verdict = 'Standart — tam ideal kesim';
        } else if (ease < 12) {
          level = 'relaxed';
          verdict = 'Rahat kesim — bol sever çocuklar için uygun';
        } else {
          level = 'loose';
          verdict = 'Bol kesim — bir alt bedeni de değerlendirebilirsin';
        }
        const pct = Math.max(6, Math.min(100, Math.round(((ease + 4) / 20) * 100)));
        const sign = ease >= 0 ? '+' : '';
        const measure = t.isBottom ? 'Basen payı' : 'Göğüs payı';

        return (
          '<article class="scfit scfit--' + level + '">' +
          '<header class="scfit__head"><span class="scfit__name">' + t.title + '</span>' +
          '<span class="scfit__badge">' + row.size + '</span></header>' +
          '<p class="scfit__verdict">' + verdict + '</p>' +
          '<div class="scfit__meter"><span class="scfit__meter-fill" style="width:' + pct + '%"></span></div>' +
          '<dl class="scfit__facts">' +
          '<div><dt>' + measure + ' (tek yön)</dt><dd>' + sign + ease.toFixed(1) + ' cm</dd></div>' +
          '<div><dt>Ürün uzunluğu</dt><dd>' + (isFinite(row.length) ? row.length + ' cm' : '—') + '</dd></div>' +
          '</dl></article>'
        );
      });

      host.innerHTML = cards.join('');
    }

    /* Boy ve kiloya gore olceklenen figur */
    updateFigure(height, weight) {
      const torso = this.querySelector('[data-figure-torso]');
      const arms = this.querySelector('[data-figure-arms]');
      const cap = this.querySelector('[data-figure-caption-model]');
      if (!torso) return;
      const hScale = 0.72 + ((height - 95) / 95) * 0.5;
      const wScale = 0.72 + ((weight - 12) / 88) * 0.75;
      const g = this.querySelector('[data-figure]');
      if (g) g.setAttribute('transform', 'translate(60 0) scale(' + wScale.toFixed(2) + ' ' + hScale.toFixed(2) + ') translate(-60 0)');
      if (cap) cap.textContent = height + ' cm · ' + weight + ' kg';
    }

    /* Boy oncelikli, kilo ile ince ayarli beden onerisi */
    updateFinder() {
      const val = (name) => {
        const el = this.querySelector('[data-input="' + name + '"]');
        return el ? Number(el.value) : 0;
      };
      const height = val('height');
      const weight = val('weight');

      const setOut = (name, text) => {
        const el = this.querySelector('[data-out="' + name + '"]');
        if (el) el.textContent = text;
      };
      setOut('height', height + ' cm');
      setOut('weight', weight + ' kg');

      const ladder = [
        { size: '5/6 yaş', max: 121, ref: 20 },
        { size: '7/8 yaş', max: 133, ref: 26 },
        { size: '9/10 yaş', max: 143, ref: 33 },
        { size: '11/12 yaş', max: 153, ref: 42 },
        { size: '13/14 yaş', max: 164, ref: 51 },
        { size: '15/16 yaş (XS)', max: 172, ref: 59 },
        { size: 'S', max: 178, ref: 65 },
        { size: 'M', max: 183, ref: 72 },
        { size: 'L', max: 187, ref: 78 },
        { size: 'XL', max: 999, ref: 86 },
      ];

      let idx = ladder.findIndex((s) => height <= s.max);
      if (idx < 0) idx = ladder.length - 1;

      const last = ladder.length - 1;
      let note = 'Boy ölçüsüne göre';
      // Ayni boyda kiz cocuklarinda referans kilo bir miktar dusuktur
      const genderFactor = this.gender === 'erkek' ? 1.04 : 0.96;
      const ref = ladder[idx].ref * genderFactor;
      if (weight > ref * 1.22 && idx < last) {
        idx += 1;
        note = 'Kilo ölçüsü nedeniyle bir üst beden';
      } else if (weight < ref * 0.78 && idx > 0) {
        note = 'İnce yapı — bol gelirse bir alt bedeni tercih edebilirsin';
      }

      const el = (sel) => this.querySelector(sel);
      const sizeEl = el('[data-result-size]');
      const hintEl = el('[data-result-hint]');
      const fillEl = el('[data-result-fill]');
      const altEl = el('[data-result-alt]');
      if (sizeEl) sizeEl.textContent = ladder[idx].size;
      if (hintEl) hintEl.textContent = note;
      if (fillEl) fillEl.style.width = Math.round(((idx + 1) / ladder.length) * 100) + '%';

      if (altEl) {
        // Tablolarda gercekten bulunmayan bir beden onerilmesin
        const sizes = this.availableSizes();
        const messages = [];
        if (sizes.size && !sizes.has(ladder[idx].size)) {
          messages.push('Bu beden bazı ürünlerde bulunmayabilir; tabloları kontrol et.');
        }
        if (idx < last) {
          const alt = ladder[idx + 1].size;
          if (!sizes.size || sizes.has(alt)) messages.push('Bol kullanmak istersen: ' + alt);
        }
        altEl.textContent = messages.join(' ');
      }

      this.renderFits(height, weight, ladder[idx].size);
      this.updateFigure(height, weight);

      // Hedef beden secildiyse olculerle karsilastir
      const targetEl = el('[data-result-target]');
      if (targetEl) {
        if (!this.targetSize) {
          targetEl.hidden = true;
          targetEl.textContent = '';
        } else {
          const tIdx = ladder.findIndex((x) => x.size === this.targetSize);
          targetEl.hidden = false;
          targetEl.classList.toggle('is-ok', tIdx === idx);
          if (tIdx === idx) {
            targetEl.textContent = 'Seçtiğin ' + this.targetSize + ' ölçülere uygun.';
          } else if (tIdx < idx) {
            targetEl.textContent = 'Seçtiğin ' + this.targetSize + ' dar kalabilir; ölçülere göre ' + ladder[idx].size + '.';
          } else {
            targetEl.textContent = 'Seçtiğin ' + this.targetSize + ' bol kalabilir; ölçülere göre ' + ladder[idx].size + '.';
          }
        }
      }
    }
  }

  if (!customElements.get('size-chart-component')) {
    customElements.define('size-chart-component', SizeChartComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
